<template>
  <v-card elevation="0" class="all-trade-tab rounded-0">
    <v-tabs :background-color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
      <v-tab class="ml-0">All</v-tab>
      <v-tab> Deposit </v-tab>
      <v-tab> Withdraw </v-tab>
      <v-tab> Transfer </v-tab>
      <v-tab> Credit In </v-tab>
      <v-tab> Credit Out </v-tab>
      <v-tab-item>
        <v-card flat>
          <AllTab></AllTab>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat>
          <DepositTab></DepositTab>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat>
          <WithdrawTab></WithdrawTab>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat>
          <TransferTab></TransferTab>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat>
          <CreditInTab></CreditInTab>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat>
          <CreditOutTab></CreditOutTab>
        </v-card>
      </v-tab-item>
    </v-tabs>
  </v-card>
</template>
<script>
import AllTab from './AllTab.vue';
import CreditInTab from './CreditInTab.vue';
import CreditOutTab from './CreditOutTab.vue';
import DepositTab from './DepositTab.vue';
import TransferTab from './TransferTab.vue';
import WithdrawTab from './WithdrawTab.vue';

export default {
  name: "LiveTradeTabs",
  components: {
    AllTab,
    DepositTab,
    WithdrawTab,
    TransferTab,
    CreditInTab,
    CreditOutTab,
  },
};
</script>
